import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { RemarkButton } from '@Components/IconButton';
import { useDisclosure } from '@hooks/useDisclosure';

import Remark from '@Components/Remark';
import { useImpactsOnStakeholdersForm } from '../ImpactsOnStakeholdersFormProvider';
import { IImpactsOnStakeholdersFormValues } from '../ImpactsOnStakeholdersFormProvider/types';

export const IMPACT_STAKEHOLDER_REMARK_ID = 'impact-stk-remark';

const ImpactsOnStakeholderOverviewRemark = () => {
  const { control, getValues } = useImpactsOnStakeholdersForm();
  const remark = getValues(
    `remark`
  ) as IImpactsOnStakeholdersFormValues['remark'];

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const remarkEl = document.getElementById(IMPACT_STAKEHOLDER_REMARK_ID);

  const [isAllCompletedTh, isAllCompletedEn] = useWatch({
    name: ['completedSection.isCompletedTh', 'completedSection.isCompletedEn'],
    control,
  });

  return (
    <>
      <RemarkButton
        onClick={open}
        disabled={isAllCompletedTh && isAllCompletedEn}
      />
      {isRemarkOpen &&
        remarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="การจัดการผลกระทบต่อผู้มีส่วนได้เสียในห่วงโซ่คุณค่าของธุรกิจ"
              setOpen={open}
              fieldPath="remark"
              isCompletedEn={isAllCompletedEn}
              isCompletedTh={isAllCompletedTh}
            />
          </Box>,
          remarkEl
        )}
    </>
  );
};

export default ImpactsOnStakeholderOverviewRemark;
